import { List, type ListProps, ListSubheader, Typography } from "@mui/material";
import { blueGrey } from "@mui/material/colors";

export function SidemenuList({
	title,
	children,
}: Pick<ListProps, "title" | "children">) {
	return (
		<List
			disablePadding
			subheader={
				title && (
					<ListSubheader sx={{ paddingLeft: 1.5, paddingBottom: 0.5 }}>
						<Typography
							variant='body2'
							color={blueGrey[600]}
							sx={{ padding: 0, fontSize: "0.8rem", fontWeight: 500 }}
						>
							{title}
						</Typography>
					</ListSubheader>
				)
			}
		>
			{children}
		</List>
	);
}
